<template>
  <div class="country__list">
    <slot :set-active-class="setActiveClass" :remove-active-class="removeActiveClass" />
  </div>
</template>

<script>
import { toggleActiveClass } from '../../utilities/mixins/toggle-active-class';
/* eslint-disable  */
export default {
  name: 'country-selector',
  
  mixins: [toggleActiveClass],

  methods: {
    removeActiveClass() {
      if (this.$el.querySelector('.active')) {
        this.$el.querySelector('.active').classList.remove('active', 'show');
      }
    },
    setActiveClass(e) {
      if (!e.target.classList.contains('active')) {
        this.removeActiveClass();
        e.target.classList.add('active', 'show');
      }
    },
  },
};
</script>
